import React from 'react';

import abl_logo from '../../assets/logo.png'
import RegisterForm from '../../Components/RegisterForm';

export default function Register() {

  const handleOnSuccess = () => {
    alert('Cadastro Realizado com sucesso!\n\nAguarde o link para o upload do filme ou o contato da Academia brasileira de Cinema e Artes Audiovisuais em caso de necessidade de complementação de materiais.');
  }

    return(
      <>
        <header>
          <figure className="logo">
            <img src={abl_logo} alt=""/>
          </figure>
        </header>
        <RegisterForm onSuccess={handleOnSuccess}/>
      </>
    )
}

